<template>
    <option :value="route">{{shortcut}}</option>
</template>

<script>
export default {

    props: ['selected', 'value', 'shortcut', 'flag', 'route'],

    setup(props) {

        return {
            props
        }
    }
}
</script>
